<template>
<div id="container" class="container geschichte_200603">
  <div class="fullscreen_background">
    <img src="/static/assets/geschichte_200603/Hintergrund_2860.png" />
  </div>
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
  <div class="miss_witch z30 dubix_animation">
  </div>
  <div class="professor_riese z30">
<img class="img" src="/static/assets/geschichte_200603/affe_anim_2.png" />
  </div>
  <div class="gigi z30">
    <img class="img" src="/static/assets/geschichte_200603/Hudu_Hugidubies_Characters_1001Nacht_08_Waechter_Halil.png" />
  </div>
  <div class="globus z30">

  </div>
   <div class="kerze z30">

  </div>
  <div class="libero z30">
    <img class="img" src="/static/assets/geschichte_200603/Glitzer_anim_2.png" />
  </div>
  <div class="kugel z40">
    <img class="img hovering" src="/static/assets/geschichte_200603/Buch_bitte_schweben_lassen.png" />
  </div>
  <!-- <div class="moebel_vorne z40">
        <img class="img" src="/static/assets/geschichte_200603/Moebel_vorne.png" />
    </div> -->

  <!-- <router-link to="/maerchengeschichten" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/geschichte_200603/Pfeil.png" />
    </router-link> -->
  <!--div class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/geschichte_200603/Pfeil-1.png" />
    </div-->

  <router-link to="/geschichte_200602" tag="div" class="pfeil_links_big z50 pointer">
    <img class="img" src="/static/assets/alle/Pfeil.png" />
  </router-link>
  <router-link tag="div" to="geschichte_200601" class="pfeil_rechts_big z50 pointer">
    <img class="img" src="/static/assets/alle/Pfeil-1.png" />
  </router-link>

  <div class="geschichte z45">
    <div class="inner">
      <img src="/static/assets/geschichte_200603/Textfeld.png" usemap="#geschichte-map">
      <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Geschichte_3_Hugi_Rafi.mp3" jsonurl="/static/assets/geschichten/hugi_ausgabe_5.json" content=".geschichte_200603" target="geschichte_200603_target" />
      <vuescrollbar tag="div" class="fliesstext" id="geschichte_200603_target">
        <p>Dubix Saladin war ein armer Fischerjunge. Jede Nacht fuhr er aufs Meer hinaus, warf sein Netz aus und holte es im Morgengrauen wieder ein. Dann lief er schnell in seine Hütte, wo seine kleine Schwester Gigi Suray und ihr Hündchen Libero Sindbad auf ihn warteten. Gigi Suray stand am Herd und kochte eine Fischsuppe. Denn seitdem der böse Sultan Soliman ihre Eltern zu sich bestellt hatte, waren sie nicht wiedergekommen und die Geschwister waren sich selbst überlassen.</p>
<p>Libero Sindbad begrüßte Dubix Saladin, der Gigi Suray auf die Stirn küsste: „Liebste Schwester“, sagte er, „heute habe ich einen besonderen Fang gemacht. Sieh, was ich dir mitgebracht habe.“ Er überreichte ihr ein Päckchen, das in Algen eingewickelt war. „Danke, lieber Bruder“, antwortete seine Schwester überrascht. Neugierig begann sie das Päckchen zu öffnen. Unter den Algen verbarg sich ein reich verziertes Buch und als sie es mit glänzenden Augen öffnete, entwichen ihm glitzernde Silberschleier und dann ein Bücherdschinn: „Salam aleikum, ihr drei, ich bin Hugi Rafi und bereit, euch euren größten Wunsch zu erfüllen.“ Die Geschwister staunten und Dubix Saladin stieß hervor: „Wir möchten unsere Eltern wiederhaben.“ Libero Sindbad bellte, Gigi Suray nahm ihn auf den Arm, beruhigte ihn und sprach leise: „Ja, bitte, bitte! Doch unsere Eltern sind im Palast des bösen Sultans Soliman gefangen. Niemand darf den Palast ohne seine Erlaubnis betreten.“</p>
<p>„Sorgt euch nicht!“, entgegnete der Bücherdschinn. Er blätterte eine Doppelseite seines Buches auf, die wunderschön und prächtig bunt mit Blumengirlanden und Vögeln verziert war. Dann nahm er die Geschwister fest bei der Hand und führte sie durch einen Buchstabenstrudel hindurch in sein Buch hinein. „Bitte schön, nehmt Platz!“, bat er sie und wies auf die Seiten des Buchs, die den dreien nun riesengroß und weich wie ein Teppich erschienen. Die Vögel auf dem Bild schwangen ihre Flügel, das Dschinnbuch hob ab und flog davon.</p>
<p>Unter ihnen leuchtete das Blau des Meeres und glühte bald der heiße Wüstensand. Dann überflogen sie die hohen Palmen einer Oase und erreichten schließlich die Tore der Stadt Sultahan. Sie überquerten sie genauso wie die Mauern des Sultanpalastes und ehe sie sich versahen, steuerten sie durch ein weit geöffnetes Fenster in den goldglänzenden Sultansaal. Das Buch landete und klappte zu. Sogleich kam die Wache des Sultans gelaufen, hob das Buch auf und brachte es Sultan Soliman, der gerade über zwei Angeklagte zu Gericht saß. Vorsichtig öffnete er das Buch.</p>
<p>Den glitzernden Silberschleiern folgten ein Bücherdschinn, zwei Kinder und ein Hündchen. „Salam aleikum, großer Sultan!“, sprach Hugi Rafi, während die Kinder sich umblickten. Da fing Libero Sindbad freudig zu bellen an, wedelte aufgeregt mit dem Schwanz und raste auf die Angeklagten zu. Tatsächlich! Es waren Mama Suleika und Papa Effim! War das ein Wiedersehen! Die ganze Familie umarmte und küsste sich. Das Hündchen sprang aufgeregt um seine Familie herum und wurde schließlich von Mama Suleika auf den Arm genommen und ebenfalls geherzt.</p>
<p>Sultan Soliman schaute verdattert drein. Gerade hatte er die Angeklagten verurteilen wollen, weil sie an die Macht der Bücher glaubten. Jetzt kamen ihre Kinder auf einem Buch hereingeflogen. Waren Bücher doch mächtig? Mächtiger als er? Sultan Soliman wollte es wissen. </p>
<p>„Lest mir vor!“, befahl er dem Dschinn. „Nichts lieber als das“, lachte dieser und begann. Bald lauschte ihm der ganze Saal. Am Abend kehrten Gigi Suray und ihr Bruder glücklich mit ihren Eltern und Libero Sindbad nach Hause zurück. Hugi Rafi aber blieb bei Sultan Soliman und las ihm noch viele Geschichten vor. So wurde er zu einem guten, gerechten und weisen Sultan. Seine berühmteste Weisheit war:</p>
        <p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
  </div>

</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
/* eslint whitespace: "off" */
/* eslint indent: "off" */
/* eslint keyword-spacing: "off" */
/* eslint no-unused-vars: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Copyright from '@/components/Copyright.vue'
import Snowf from 'vue-snowf'
import Lautsprecher from '@/components/Lautsprecher.vue'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'geschichte_200603',
  data () {
    return {
      who: 'geschichte_200603',
      sternchen: '/static/assets/geschichte_200603/sternchen.png',
      audioposition: 0
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright, 
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () { 
    this.$ga.page(this.$router)
    var self = this
    setTimeout(function () {
      var muted = (typeof self.$root.muted !== 'undefined' ? self.$root.muted : false)
      try {
        window.currentAudioX.pause()
        window.currentAudioX.currentTime = 0
        window.currentAudioX = null
      } catch (e) {
            console.log('pause geht nicht')
      }
      try {
        window.currentAudio.pause()
        window.currentAudio.currentTime = 0
        window.currentAudio = null
      } catch (e) {
            console.log('pause geht nicht')
      }
      window.currentAudioX = new Audio ('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Archivseite_Hugi_Titel_Hugi_Rafi.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }

      window.hintergrundSound = new Audio ('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Hugi_Rafi_Atmo_II.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined'?   window.muted : false)
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e) {
        window.bgsounddisabled = true
      }


    }, 1000);
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
      console.log('hintergrundsound nicht aktiv')
    }

  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* Z-Index - Level */

.z1 {
  z-index: 10;
}

.z2 {
  z-index: 20;
}

.z3 {
  z-index: 30;
}

.z4 {
  z-index: 40;
}

.z5 {
  z-index: 50;
}

.z6 {
  z-index: 60;
}

.z7 {
  z-index: 70;
}

.z8 {
  z-index: 80;
}

.z9 {
  z-index: 90;
}

.z10 {
  z-index: 100;
}

.z11 {
  z-index: 110;
}

.z12 {
  z-index: 120;
}

.z13 {
  z-index: 130;
}

.z14 {
  z-index: 140;
}

.z15 {
  z-index: 150;
}

.z16 {
  z-index: 160;
}

.z17 {
  z-index: 170;
}

.z18 {
  z-index: 180;
}

.z19 {
  z-index: 190;
}

.z20 {
  z-index: 200;
}

.z21 {
  z-index: 210;
}

.z22 {
  z-index: 220;
}

.z23 {
  z-index: 230;
}

.z24 {
  z-index: 240;
}

.z25 {
  z-index: 250;
}

.z26 {
  z-index: 260;
}

.z27 {
  z-index: 270;
}

.z28 {
  z-index: 280;
}

.z29 {
  z-index: 290;
}

.z30 {
  z-index: 300;
}

.z31 {
  z-index: 310;
}

.z32 {
  z-index: 320;
}

.z33 {
  z-index: 330;
}

.z34 {
  z-index: 340;
}

.z35 {
  z-index: 350;
}

.z36 {
  z-index: 360;
}

.z37 {
  z-index: 370;
}

.z38 {
  z-index: 380;
}

.z39 {
  z-index: 390;
}

.z40 {
  z-index: 400;
}

.z41 {
  z-index: 410;
}

.z42 {
  z-index: 420;
}

.z43 {
  z-index: 430;
}

.z44 {
  z-index: 440;
}

.z45 {
  z-index: 450;
}

.z46 {
  z-index: 460;
}

.z47 {
  z-index: 470;
}

.z48 {
  z-index: 480;
}

.z49 {
  z-index: 490;
}

.z50 {
  z-index: 500;
}

/* geschichte_200603 */

.geschichte_200603 {
  position: absolute;
  width: 1920px;
  height: 1080px;
  top: 0;
}

.geschichte_200603 .himmel {
  display: block !important;
}

.geschichte_200603 .geschichte {
  position: absolute;
  top: 170px;
  left: 51%;
}

.geschichte_200603 .geschichte .inner {
  position: relative;
}



.geschichte_200603 .pfeil_links_big {
  position: absolute;
  left: 1vw;
  top: 40%;
}

.geschichte_200603 .pfeil_rechts_big {
  position: absolute;
  right: 1vw;
  top: 40%;
}

.geschichte_200603 .moebel_vorne {
  position: absolute;
  bottom: 0;
  left: 0;
}

.geschichte_200603 .miss_witch {
  position: absolute;
  /* top: 50%; left: 21%; */
  top: 47%;
  left: 23%;
}

.geschichte_200603 .professor_riese {
  position: absolute;
    top: -354px;
    right: -640px;
  opacity:0;
  animation: riese_erscheint 1s;
  animation-fill-mode: forwards;
  animation-delay: 0.75s;
}

@keyframes riese_erscheint {
  /* 0% {
    right: -3%;
    opacity: 0;
  }
  100% {
    right: 3%;
    opacity: 1;
  } */
  50% {
    transform: scale(0.5);
    top: -100px !important;
    right: -1020px !important;
    opacity: 0;
  }
  100% {
    transform: scale(1);
    top: -354px;
    right: -640px;
    opacity: 1;
  }
}

.geschichte_200603 .libero {
  position: absolute;
    top: -210px;
    left: -371px;
}

.geschichte_200603 .libero {
  animation: libero_erscheint 2s ease-out;
  animation-delay: 2s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
}

@keyframes libero_erscheint {
  50% {
    opacity: 0; 
  }
  100% {
    opacity: 1; 
  }
}

.geschichte_200603 .gigi {
  position: absolute;
    top: 895px;
    left: 838px;
}

.geschichte_200603 .gigi img {
  animation-delay: 8s;
  animation: gigi_erscheint 1s;
  transform-origin: bottom center;
}

@keyframes gigi_erscheint {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  80% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.geschichte_200603 .fliesstext {
    bottom: 28%;
    left: 13.5%;
    width: 74%;
  font-size: 16pt;
  font-family: 'Open Sans';
  font-weight: 400;
  position: absolute;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 450px;
  padding-right: 15px;
}

.geschichte_200603 div.fliesstext>span {
  margin-right: 8px !important;
  float: left !important;
}

::-webkit-scrollbar {
  width: 15px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0px #ac8a69;
  box-shadow: inset 0 0 0px #ac8a69;
  -webkit-border-radius: 0;
  border-radius: 0;
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: #ac8a69;
}

::-webkit-scrollbar-thumb:window-inactive {
  background: #ac8a69;
}

::-webkit-scrollbar-button {
  background: none;
}

::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat;
}

::-webkit-scrollbar-button:vertical:decrement {
  background-image: url(http://www.fruehling.eu/wp-content/uploads/2018/02/arrow_up.png);
  background-position: 0px 0px;
}

::-webkit-scrollbar-button:vertical:increment {
  background-image: url(http://www.fruehling.eu/wp-content/uploads/2018/02/arrow_do.png);
  background-position: 0px 0px;
}

.snowf-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 150% !important;
  height: 150% !important;
  left: -25% !important;
  z-index: 30 !important;
}

.dubix_animation {
  width: 320px;
  height: 320px;
  animation-delay: 2s; 
  animation: play_dubix 4s steps(5) infinite;
  transform: scale(1);
  margin-top: -25px;
  margin-left: -50px;
}

@keyframes play_dubix {
  0% {
    background-position: 0 0px;
  }
  50% {
    background-position: 0 -1600px;
  }
  100% {
    background-position: 0 -1600px;
  }
}

.globus {
  width: 350px;
  height: 350px; 
  animation-delay: 2s; 
  animation: play_globus 4s steps(6) infinite;
  transform: scale(0.465);
  top: -87px;
  left: 849px;
  position: absolute;
}

@keyframes play_globus {
  0% {
    background-position: 0 0px;
  }
  50% {
    background-position: 0 -2100px;
  }
  100% {
    background-position: 0 -2100px;
  }
}
.kerze {
    width: 380px;
    height: 529px; 
    animation: play_kerze 2s steps(8) infinite;
    transform: scale(0.26);
    top: 533px;
    left: 728px;
    position: absolute;
}

@keyframes play_kerze {
  0% {
    background-position: 0 0px;
  }
  100% {
    background-position: 0 -4232px;
  }
}
.kugel.z30 {
  position: absolute;
  top: 420px;
  left: 350px;
}

.kugel {
  position: absolute;
  animation: hexe_erscheint 10s linear;
  animation-delay: 0.75s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
  margin-top: -800px;
}

@keyframes hexe_erscheint {
  0% {
    margin-top: 260px;
    opacity: 0;
    margin-left: 860px;
    transform: scale(0.5);
  }
  25% {
    opacity: 1;
  }
  50% {
    opacity: 1;
    transform: scale(0.75);
    margin-top: 160px;
    margin-left: 410px;
  }
  100% {
    margin-left: 120px;
    opacity: 1;
    margin-top: 110px;
  }
}

.hovering {
  -webkit-animation: hovering 8s ease-in-out infinite;
  -moz-animation: hovering 8s ease-in-out infinite;
  -ms-animation: hovering 8s ease-in-out infinite;
  -o-animation: hovering 8s ease-in-out infinite;
  animation: hovering 8s ease-in-out infinite;
}

@-webkit-keyframes hovering
/* Safari and Chrome */

  {
  0% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  50% {
    -ms-transform: translate(0px, 20px);
    -moz-transform: translate(0px, 20px);
    -webkit-transform: translate(0px, 20px);
    -o-transform: translate(0px, 20px);
    transform: translate(0px, 20px);
  }
  100% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

@keyframes hovering {
  0% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  /* 25% {
    -ms-transform: translate(-20px,20px);
    -moz-transform: translate(-20px,20px);
    -webkit-transform: translate(-20px,20px);
    -o-transform: translate(-20px,20px);
    transform: translate(-20px,20px);
  }
 */
  50% {
    -ms-transform: translate(0px, 20px);
    -moz-transform: translate(0px, 20px);
    -webkit-transform: translate(0px, 20px);
    -o-transform: translate(0px, 20px);
    transform: translate(0px, 20px);
  }
  /*  75% {

    -ms-transform: translate(20px,20px);
    -moz-transform: translate(20px,20px);
    -webkit-transform: translate(20px,20px);
    -o-transform: translate(20px,20px);
    transform: translate(20px,20px);
  }
*/
  100% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

span {
  font-family: FrozenMemory;
}
.player{
    position: absolute;
    top: 700px;
    left: 130px;
    width: 475px;
}
</style> 



// WEBPACK FOOTER //
// src/components/Geschichte_200603.vue